angular.module("sintesiEstinzione.components", [])
    .component("sintesiEstinzione", {
        templateUrl: "ng/components/riscattoAnticipato/sintesiEstinzione/sintesiEstinzione.view.html",
        bindings: {
            richiestePostVendita: '=',
            numContratto: "<",
            numModulo: "<",
            postVendita: "<",
            validateComponent: "&"
        },
        controller: SintesiEstinzioneController,
        controllerAs: "sintesiEstinzioneCtrl"
    })

function SintesiEstinzioneController(
    $arcService,
    $download,
    $filter,
    $rootScope
) {
    var self = this;

    var initProvince = function () {
        self.supportModel.provinceType = $rootScope.comuniMap
            .map(function (comune) {
                return comune.sigla;
            })
            .filter(function (siglaComune) {
                return siglaComune != "";
            })
            .sort()
            .reduce(function (result, nextItem) {
                return result.includes(nextItem) ? result : result.concat(nextItem);
            }, []);
    };

    self.$onInit = function () {
        getSintesi()
        self.supportModel = {
            provinceType: [],
            restIsPending: false,
            preventiveAccepted: false,
            preventivePrinted: false,
            restDownloadRunning: false,
            documento: {},
            initialIndex: 0,
            title: "",
            contattiRiscattante: {
                telefono: self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante && self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.telefono ? self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.telefono : "",
                email: self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante && self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.email ? self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.email : ""
            }
        }
        initProvince();
        if (self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTotale) {
            self.supportModel.title = $filter("translate")("LBL_SINTESI_ESTINZ") + " " + $filter("translate")("SIM_TOTAL") + " id " + self.richiestePostVendita.id + " contratto " + self.numContratto + "/" + self.numModulo;
        } else {
            self.supportModel.title = $filter("translate")("LBL_SINTESI_ESTINZ") + " id " + self.richiestePostVendita.id + " contratto " + self.numContratto + "/" + self.numModulo;
        }
    }

    var getSintesi = function () {
        $arcService.getSintesiEstinzione(self.richiestePostVendita)
            .then(function (response) {
                self.showHideTalbeInfo = response.visible;
                self.supportModel.documento = response.documento
                self.spese = response.spese
                self.richiestePostVendita.metadata.riscattoAnticipato.importoTot = response.importoTot;
                self.richiestePostVendita.metadata.riscattoAnticipato.dataRif = response.dataRif;
                self.richiestePostVendita.metadata.riscattoAnticipato.pagobolloAttivo = response.pagobolloAttivo;
                self.richiestePostVendita.metadata.riscattoAnticipato.importoTot = response.tipoVeicolo;
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    self.printPreventive = function () {
        self.supportModel.restIsPending = true;
        if (self.supportModel.documento.listDocuments && self.supportModel.documento.listDocuments.length) {
            self.generdownloadDoc(self.supportModel.documento.listDocuments[0])

        }
    }

    self.generdownloadDoc = function (file) {
        var input = {
            downloadKey: file.downloadKey
        }
        var url = "/uni/downloadDocPv/service-infos/";
        $download.getGenericDownload(url, input)
            .then(function (response) {
                self.supportModel.restIsPending = false;
                self.supportModel.preventivePrinted = true;
                checkValidityComponent();
            })
            .catch(function (error) {
                console.log(error)
                self.supportModel.restIsPending = false;
                self.supportModel.preventivePrinted = false;
                checkValidityComponent();
            })
    };

    var checkValidityComponent = function () {
        if (!self.richiestePostVendita.metadata.riscattoAnticipato.riscattoTerzo) {
            if (self.supportModel.preventivePrinted) {
                self.validateComponent({
                    validity: true
                });
            } else {
                self.validateComponent({
                    validity: false
                });
            }
        } else {
            var test = true;
            if (self.richiestePostVendita.metadata.riscattoAnticipato.external) {
                if (self.richiestePostVendita.metadata.riscattoAnticipato.riscattantePef) {
                    test = test &&
                        self.richiestePostVendita.metadata.riscattoAnticipato.nomeRiscattante &&
                        self.richiestePostVendita.metadata.riscattoAnticipato.cognomeRiscattante &&
                        self.richiestePostVendita.metadata.riscattoAnticipato.cfTerzo

                } else {
                    test = test &&
                        self.richiestePostVendita.metadata.riscattoAnticipato.pivaTerzo &&
                        self.richiestePostVendita.metadata.riscattoAnticipato.cfTerzo

                }

            }
            if (self.supportModel.preventivePrinted &&
                self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.email &&
                self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.telefono &&
                self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante.description &&
                test) {
                self.validateComponent({
                    validity: true
                });
            } else {
                self.validateComponent({
                    validity: false
                });
            }
        }
    }

    self.handleChange = function (property, value) {
        self.richiestePostVendita.metadata.riscattoAnticipato.contattiRiscattante[property] = value;
        checkValidityComponent();
    }

    self.handleChangeExternal = function (property, value) {
        self.richiestePostVendita.metadata.riscattoAnticipato[property] = value;
        checkValidityComponent();
    }

}